import {
    ADD_FAVORITE,
    ADD_FAVORITE_ERROR,
    ADD_FAVORITE_SUCCESS,
    GET_FAVORITES,
    GET_FAVORITES_ERROR,
    GET_FAVORITES_SUCCESS,
    GET_MEMBER_PROMOTIONS,
    GET_MEMBER_PROMOTIONS_ERROR,
    GET_MEMBER_PROMOTIONS_SUCCESS,
    GET_USER,
    GET_USER_SUCCESS,
    REMOVE_BONUSCARD,
    REMOVE_BONUSCARD_ERROR,
    REMOVE_BONUSCARD_SUCCESS,
    REMOVE_FAVORITE,
    REMOVE_FAVORITE_ERROR,
    REMOVE_FAVORITE_SUCCESS,
    REMOVE_USER,
    REMOVE_USER_ERROR,
    REMOVE_USER_SUCCESS,
    SET_USER_SUCCESS,
    SIGN_IN,
    SIGN_IN_ERROR,
    SIGN_IN_SUCCESS,
    SIGN_OUT,
    SIGN_OUT_ERROR,
    SIGN_OUT_SUCCESS,
    UPDATE_BONUSCARD,
    UPDATE_BONUSCARD_ERROR,
    UPDATE_BONUSCARD_SUCCESS,
    UPDATE_USER,
    UPDATE_USER_ERROR,
    UPDATE_USER_SUCCESS,
} from "./constants";

import produce from "immer";

const initialState = {
    city: "",
    code: "",
    displayName: "",
    email: "",
    favorites: [],
    fetchingFavorites: false,
    firstName: "",
    userId: "",
    initFetchingFavorites: false,
    interestAnimals: {},
    isAuth: false,
    isInitialized: false,
    lastName: "",
    loading: false,
    loadingFavorite: false,
    notificationPreferences: {},
    phoneNumber: "",
    promotions: [],
    promotionsLoading: true,
    street: "",
    zipCode: null,
    bonuscardNumber: "",
    bonusPoints: 0,
    memberLevel: {
        rewardPoints: 0,
        expires: null,
        levelId: null,
        levelName: null,
        pointsToNextLevel: 0,
    },
};
export default produce((state, action) => {
    switch (action.type) {
        case GET_USER:
        case SIGN_IN:
            state.isInitialized = true;
            state.loading = true;
            state.initFetchingFavorites = true;
            break;

        case GET_USER_SUCCESS:
        case SIGN_IN_SUCCESS:
            state.initFetchingFavorites = false;
            state.loading = false;
            state.isAuth = true;
            break;

        case ADD_FAVORITE:
        case REMOVE_FAVORITE:
            state.loadingFavorite = true;
            break;

        case GET_FAVORITES:
            state.fetchingFavorites = true;
            break;

        case ADD_FAVORITE_SUCCESS:
            state.loadingFavorite = false;
            state.favorites.push(action.partNo);
            break;

        case GET_FAVORITES_SUCCESS:
            state.favorites = action.products;
            state.fetchingFavorites = false;
            break;

        case REMOVE_FAVORITE_SUCCESS:
            state.favorites = state.favorites.filter((item) => {
                return item !== action.partNo;
            });
            state.loadingFavorite = false;
            break;

        case ADD_FAVORITE_ERROR:
        case REMOVE_FAVORITE_ERROR:
        case SIGN_IN_ERROR:
            state.loading = false;
            break;

        case GET_FAVORITES_ERROR:
            state.fetchingFavorites = false;
            break;

        case SET_USER_SUCCESS: {
            const name = [action.firstName, action.lastName].filter(Boolean).join(" ");
            state.userId = action.userId;
            state.street = action.street;
            state.city = action.city;
            state.zipCode = action.zipCode;
            state.displayName = name
                .split(" ")
                .map((n) => n[0])
                .join("");
            state.email = action.email;
            state.favorites = action.favorites || [];
            state.firstName = action.firstName;
            state.interestAnimals = action.interestAnimals;
            state.lastName = action.lastName;
            state.phoneNumber = action.phoneNumber;
            state.notificationPreferences = action.notificationPreferences;
            state.bonuscardNumber = action.bonuscardNumber;
            state.bonusPoints = action.bonusPoints;
            state.memberLevel = action.memberLevel;
            break;
        }

        case UPDATE_USER:
            state.loading = true;
            break;

        case UPDATE_USER_SUCCESS: {
            state.city = action.city;
            state.email = action.email;
            state.firstName = action.firstName;
            state.lastName = action.lastName;
            state.phoneNumber = action.phoneNumber;
            state.street = action.street;
            state.zipCode = action.zipCode;
            state.loading = false;

            break;
        }
        case UPDATE_USER_ERROR:
            state.loading = false;
            break;
        case GET_MEMBER_PROMOTIONS:
            state.promotionsLoading = true;
            break;
        case GET_MEMBER_PROMOTIONS_SUCCESS:
            state.promotions = action.promotions;
            state.promotionsLoading = false;
            break;
        case GET_MEMBER_PROMOTIONS_ERROR:
            state.promotionsLoading = false;
            state.promotions = [];
            break;
        case SIGN_OUT:
        case REMOVE_USER:
            state.loading = true;
            break;
        case SIGN_OUT_SUCCESS:
        case REMOVE_USER_SUCCESS:
            return initialState;
        case SIGN_OUT_ERROR:
        case REMOVE_USER_ERROR:
            state.loading = false;
            break;

        case UPDATE_BONUSCARD:
            state.loading = true;
            break;
        case UPDATE_BONUSCARD_SUCCESS:
            state.bonuscardNumber = action.bonuscardNumber;
            state.loading = false;
            break;
        case UPDATE_BONUSCARD_ERROR:
            state.loading = false;
            break;
        case REMOVE_BONUSCARD:
            state.loading = true;
            break;
        case REMOVE_BONUSCARD_SUCCESS:
            state.bonuscardNumber = "";
            state.loading = false;
            break;
        case REMOVE_BONUSCARD_ERROR:
            state.loading = false;
            break;
        default:
            break;
    }
}, initialState);
